module.exports = __webpack_public_path__ + "static/img/applicableScene1.81b9e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene1.png
// module id = ZUzS
// module chunks = 0